const TOAST_STYLE_BY_TYPE = Object.freeze({
  success: {
    color: '#03C75A',
    background: '#000000',
    border: '1px solid #919191',
  },
  timeout: {
    color: '#FFFFFF',
    background: '#000000',
    border: '1px solid #919191',
  },
  near: {
    color: '#FFBC2B',
    background: '#000000',
    border: '1px solid #919191',
  },
  default: {
    color: '#FFFFFF',
    background: '#000000',
    border: '1px solid #919191',
  },
});

export default function TimeNyangBottomToast({ events = [] }) {
  if (!Array.isArray(events) || events.length === 0) return null;

  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-[96px] z-[45] flex flex-col items-center gap-2 px-6">
      {events.map((event) => {
        const style = TOAST_STYLE_BY_TYPE[event.type] ?? TOAST_STYLE_BY_TYPE.default;
        return (
          <div
            key={event.id}
            className="time-nyang-reward-toast rounded-[5px] px-[20px] py-[10px] text-center font-['Pretendard'] text-[12px] font-normal leading-[1.4] tracking-[0]"
            style={{
              color: style.color,
              background: style.background,
              border: style.border,
            }}
          >
            {event.text}
          </div>
        );
      })}
    </div>
  );
}
